import strevBlackAndBlueLogo from '@/assets/icons/strev/strev-black-and-blue-logo.png';

type FaviconAsset = {
  rel: 'icon' | 'shortcut icon' | 'apple-touch-icon';
  href: string;
  type?: string;
  sizes?: string;
};

type LogoAssets = {
  sidebar: string;
  login: string;
};

export type ThemeConfig = {
  whiteLabel: string;
  brandName: string;
  brandMark: string;
  supportEmail: string;
  tokens: Record<string, string>;
  logos: LogoAssets;
  favicons: FaviconAsset[];
};

const WHITE_LABEL_CONFIGS: Record<string, ThemeConfig> = {
  strev: {
    whiteLabel: 'strev',
    brandName: 'Strev',
    brandMark: 'ST',
    supportEmail: 'admin-support@revnue.com',
    tokens: {
      '--theme-color': '#0f6cbd',
      '--theme-color-strong': '#0a4f8a',
      '--theme-font-color': '#0f172a',
      '--theme-muted-color': '#5b6475',
      '--theme-border-color': '#d8e0ec',
      '--theme-sidebar-color': '#0f172a',
      '--theme-sidebar-accent': '#172033',
      '--theme-surface-color': '#ffffff',
      '--theme-app-bg': '#eef3f9',
      '--theme-input-bg': '#f8fafc',
      '--theme-success': '#0f9d58',
      '--theme-warning': '#b7791f',
      '--theme-danger': '#c53030',
    },
    logos: {
      sidebar: '/strev/strev-white-logo.svg',
      login: strevBlackAndBlueLogo,
    },
    favicons: [
      {
        rel: 'icon',
        href: '/strev/favicon-16px.png',
        type: 'image/png',
        sizes: '16x16',
      },
      {
        rel: 'icon',
        href: '/strev/favicon-32px.png',
        type: 'image/png',
        sizes: '32x32',
      },
      {
        rel: 'shortcut icon',
        href: '/strev/shortcut-32px.ico',
        type: 'image/x-icon',
      },
      {
        rel: 'apple-touch-icon',
        href: '/strev/favicon-144px.png',
        type: 'image/png',
        sizes: '144x144',
      },
    ],
  },
};

const DEFAULT_WHITE_LABEL = 'strev';
const selectedWhiteLabel = (import.meta.env.VITE_WHITE_LABEL ?? DEFAULT_WHITE_LABEL).toLowerCase();

export const brandingConfig = WHITE_LABEL_CONFIGS[selectedWhiteLabel] ?? WHITE_LABEL_CONFIGS[DEFAULT_WHITE_LABEL];
